<template>
  <!-- 游戏选择弹出框组件 - 使用TDesign的t-popup组件 -->
  <t-popup
    v-model:visible="visible"
    :placement="'left'"
    overlay-inner-class-name=" bg-[#3a435d] rounded-lg shadow-none p-[16px] overflow-hidden"
  >
    <!-- 游戏选择器触发按钮 - 支持短模式和完整模式 -->
    <div
      variant="outline"
      class="relative flex justify-between items-center rounded-lg game-icon-item cursor-pointer h-[48px] border-black-secondary transition-[width] bg-white bg-opacity-10"
      :class="[!short ? '' : ' border']"
    >
      <!-- 游戏图标容器 - 固定48x48尺寸 -->
      <div
        class="w-[48px] h-[48px] p-[8px] rounded-default bg-gradient-to-t bg-no-repeat bg-cover"
        @click="handleGameNameShow"
      >
        <game-icon :icon="getIconByLoginType()" />
      </div>

      <!-- 游戏标题区域 - 仅在非短模式下显示 -->
      <div
        v-if="!short"
        class="game-title flex justify-start items-center pl-[16px] pr-[16px] h-full flex-1"
      >
        <!-- 游戏名称文本 - 支持溢出显示和工具提示 -->
        <!-- <Text
          class="block w-[84px]"
          :class="{ 'w-0': short }"
          color="var(--aix-text-color-white-primary)"
          size="title"
          :content="getGameNameShow"
          overflow
          tool-tip
        /> -->
        <div class="text-white flex items-center w-[65%] justify-center">{{ getGameNameShow }}</div>
        <!-- 下拉箭头图标 -->
        <!-- <t-icon
          name="chevron-down"
          class="text-gray-secondary"
        /> -->
      </div>

      <!-- 切换图标 - 位于右下角的小图标 -->
      <div
        class="flex justify-center items-center absolute w-4 h-4 bg-game-icon rounded-game-icon bottom-1 right-1 p-0.5 box-border z-10"
      >
        <SvgIcon
          name="change"
          size="14"
          color="#fff"
        />
      </div>
    </div>

    <!-- 弹出框内容 - 游戏列表下拉菜单 -->
    <template #content>
      <Dropdown
        :options="gameStore.gameList"
        title="All Game List"
        :default-select-value="gameStore.currentGameItem"
        @game-value="updateGameValue"
      />
    </template>
  </t-popup>
</template>

<script setup lang="ts">
// 导入依赖组件和工具
import Dropdown from './Dropdown.vue';
import GameIcon from '@/components/GameIcon.vue';
import type { GameItem } from './type';
import { useGlobalGameStore, getGameIcon } from '@/store/global/game.store';
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { SvgIcon } from '@tencent/aix-design';

// 组件属性定义
defineProps({
  short: {
    type: Boolean,
    default: false, // 是否为短模式（仅显示图标）
  },
});

// 状态管理和路由
const gameStore = useGlobalGameStore(); // 全局游戏状态管理
const visible = ref(false); // 控制弹出框显示/隐藏
const router = useRouter(); // 路由实例
const route = useRoute(); // 当前路由信息

/**
 * 更新游戏选择值
 * @param item 选中的游戏项
 * 功能：通过路由参数切换游戏，保持其他查询参数不变
 */
const updateGameValue = (item: GameItem) => {
  // 如果没有children的话就代表有game code
  // 通过更改路由来更改gameCode
  router.replace({
    path: route.path.toString(),
    query: {
      game: item.value, // 更新游戏代码
      cgiMode: route.query.cgiMode, // 保持CGI模式
      dbMode: route.query.dbMode, // 保持数据库模式
    },
  });
  visible.value = false; // 关闭弹出框
};

/**
 * 获取游戏图标
 * @returns 游戏图标路径或默认图标
 * 功能：优先使用当前游戏项的图标，否则使用默认图标
 */
const getIconByLoginType = () => gameStore?.currentGameItem?.icon || getGameIcon(gameStore?.currentGameItem as any);

// 显示游戏名
const getGameNameShow = computed(() => {
  console.log('handleGameNameShow', gameStore?.gameCfg);
  const gameName = Object.values(gameStore?.gameCfg)[0]?.name;
  // const gameNameValue = gameName[0]?.name;
  console.log('获取到的游戏名称：', gameName); // 输出 "DLTB"
  // const targetGame = gameName.find((item) => item?.name);
  // // 从找到的对象中提取 name
  // const gameNameValue = targetGame?.name;
  // console.log('获取到的游戏名称：', gameNameValue); // 输出 "DLTB"
  return gameName;
});
</script>

<style scoped lang="scss">
/* 游戏图标项悬停效果 - 毛玻璃效果和渐变背景 */
.game-icon-item {
  // background: linear-gradient(110.28deg, rgba(37, 44, 56, 0.6) 0.2%, rgba(80, 94, 119, 0.6) 101.11%);
  background: linear-gradient(110.28deg, rgba(153, 98, 158, 0.6) 0.2%, rgba(49, 82, 139, 0.6) 101.11%);

  box-shadow: 23px 23px 34px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(25px); /* 毛玻璃效果 */
  // @apply rounded-default;
  border-color: transparent;
}
</style>
